import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToHashLink from './ScrollToHashLink';

const Header = () => {
  return (
    <header className="bg-soft-sky shadow-md sticky top-0 z-50">
      <div className="max-w-[92rem] w-full mx-auto flex items-center h-24 px-6">
        {/* Left: Logo */}
        <div className="flex-1 flex items-center">
          <img
            src="/images/betterturnslogo.svg"
            alt="BetterTurns Co-op logo"
            className="w-[140px] md:w-[160px] lg:w-[200px] h-auto"
          />
        </div>

        {/* Center: Title SVG */}
        <div className="flex-2 flex justify-center">
          <img
            src="/images/TheCoop.svg"
            alt="The CO-OP title"
            className="w-[250px] sm:w-[320px] md:w-[380px] lg:w-[420px]"
          />
        </div>

        {/* Right: Navigation */}
        <div className="flex-1 hidden md:flex justify-end space-x-5 text-base font-bold text-deep-navy">
          <Link
            to="/"
            className="hover:text-primary"
          >
            Home
          </Link>
          <ScrollToHashLink
            hash="about"
            className="hover:text-primary"
          >
            About
          </ScrollToHashLink>
          <Link
            to="/join"
            className="hover:text-primary"
          >
            Join
          </Link>
          <Link
            to="/resources"
            className="hover:text-primary"
          >
            Resources
          </Link>
          <Link
            to="/login"
            className="hover:text-primary"
          >
            Login
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
